import store from './../../vuex/store'

export default {
  getCardTypes() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/cardTypes']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getCardTypes').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getCardBelongType() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/cardBelongType']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getCardBelongType').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getCardStates() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/cardStates']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getCardStates').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getPaymentType() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/payTypes']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getPaymentType').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getParamCode() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/paramCodes']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getParamCode').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getPayment() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/paymentType']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getPayment').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getChecked() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/checkedList']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getChecked').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getRoleTypes() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/roleTypes']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getRoleTypes').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getOrderStatus() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/orderStatus']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getOrderStatus').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getPayStatus() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/payStatus']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getPayStatus').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getPayChannelEnum() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/payChannels']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getPayChannelEnum').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getTradeTypeEnum() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/tradeTypes']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getTradeTypeEnum').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getPayWayEnum() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/payWays']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getPayWayEnum').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getRefundTypeEnum() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/refundTypes']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getRefundTypeEnum').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getMemberAppType() {
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/member_appType']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getMemberAppType').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getRequestSource(){
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/requestSource']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getRequestSource').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getRechargeType(){
    return new Promise((resolve, reject) => {
      let list = store.getters['enums/cardRechargeType']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('enums/getCardRechargeType').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/api/enumFromVuexApi.js